import React, { useMemo } from "react";
import { Layout } from "../layout/Layout.js";
import { TemplateForm } from "./TemplateForm.js";
import { TemplateChanges } from "./TemplateChanges.js";
import { TemplateEntry } from "./TemplateEntry.js";
import { useRequiredParameter } from "../../../packages/router/params/useRequiredParameter.js";
import { TEMPLATES } from "../../model/accounting/templates/Templates.js";
import { TemplateProvider } from "./TemplateProvider.js";

/**
 * Shows one accounting entry template page.
 */
export const TemplatePage = () => {
  const templateId = useRequiredParameter("templateId");

  const template = useMemo(() => {
    const template = TEMPLATES.find((template) => template.id === templateId);
    if (!template) {
      throw new Error(`No template ${templateId}.`);
    }
    return template;
  }, [templateId]);

  return (
    <Layout title={`Vorm ${template.name}`} containerWidth="fixed-wide-min">
      <TemplateProvider template={template}>
        <h2>Vorm {template.name}</h2>
        <p className="template-description">{template.description}</p>
        <TemplateForm />
        <TemplateEntry />
        <TemplateChanges />
      </TemplateProvider>
    </Layout>
  );
};
